<template>
  <div v-show="show" class="desktop-flow-shortcut">
    <ul class="flow-shortcut">
      <template v-for="(item, key) in quickBars">
        <li v-if="item.type === 'web'" :key="key" class="flow-shortcut-item" :class="getHoverClass(key)" @click="goLink(item.url)">
          <div class="flow-shortcut-content">
            <div class="flow-shortcut-icon small">
              <img :src="item.image" alt="">
            </div>
            <div class="flow-shortcut-text">
              {{ item.label }}
            </div>
          </div>
          <div v-if="item.enable_hover" class="flow-shortcut-name">
            <p>
              {{ item.text_hover }}<br>
            </p>
            <div class="flow-shortcut-img">
              <img :src="item.image_hover" alt="">
            </div>
          </div>
        </li>
      </template>
      <li v-if="$store.getters.permissionInfo.enable_roll" class="flow-shortcut-item chat" @click="rollLaunch()">
        <div class="flow-shortcut-content">
          <div class="flow-shortcut-icon small">
            <img src="@/assets/images/upload/img_roll.svg" alt="">
          </div>
          <div class="flow-shortcut-text">
            {{ $t('Bao.roll_room') }}
          </div>
        </div>
      </li>
      <li v-if="$store.getters.urlInfo.websocketChatUrl" class="flow-shortcut-item chat" @click="enterChat()">
        <div class="flow-shortcut-content">
          <div class="flow-shortcut-icon small">
            <img src="@/assets/images/upload/quick_chat.svg">
            <small
              v-if="!$store.state.user.lastChatMessage.read"
              class="tips position-absolute rounded-circle"
            />
          </div>
          <div class="flow-shortcut-text">
            {{ $t('Bao.chat_room') }}
          </div>
        </div>
      </li>
      <li>
        <div class="d-flex align-items-center justify-content-center">
          <button class="btn btn_close p-0 border-0 bg-transparent" type="button" @click="show=false">
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
              <rect width="12.856" height="1.286" rx="0.643" transform="translate(0.909 0) rotate(45)" fill="#afafaf" />
              <rect width="12.856" height="1.286" rx="0.643" transform="translate(10 0.909) rotate(135)" fill="#afafaf" />
            </svg>
          </button>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { getQuickBar } from '@/api/brand'
import { rollStart } from '@/utils/roll'
import { handleTokenUrl } from '@/utils/tool'

export default {
  data() {
    return {
      show: true,
      quickBars: [],
      hoverColor: [
        'service',
        'app',
        'net',
        'toff',
        'chat'
      ]
    }
  },
  watch: {
    '$store.state.user.token'() {
      // 監測登入登出的時候改變含有token的url
      this.checkTokenUrl()
    }
  },
  created() {
    getQuickBar().then(response => {
      this.quickBars = response.data.data
      this.checkTokenUrl()
    })
  },
  methods: {
    getHoverClass(key) {
      const i = key % 5
      return this.hoverColor[i]
    },
    goLink(url) {
      if (url === 'DailyBox') {
        if (this.$store.getters.token) {
          this.$bvModal.show('modal_daily_box')
        } else {
          this.$bvModal.show('modal_login_box')
        }
      } else {
        window.open(url, '_blank')
      }
    },
    getChatSrc() {
      let charSrc = this.$store.getters.urlInfo.websocketChatUrl
      if (charSrc && this.$store.getters.token) {
        charSrc += '&token=' + this.$store.getters.token
      }

      return charSrc
    },
    enterChat() {
      const url = this.getChatSrc()
      window.open(url)
      this.$store.commit('SET_LAST_CHAT_MESSAGE', {
        uuid: this.$store.state.user.lastChatMessage.uuid,
        read: true
      })
    },
    rollLaunch() {
      rollStart()
    },
    checkTokenUrl() {
      for (const i in this.quickBars) {
        if (this.quickBars[i].url.indexOf('token=') > -1) {
          this.quickBars[i].url = handleTokenUrl(this.quickBars[i].url, this.$store.getters.token)
        }
      }
    }
  }
}
</script>

<style>
.tips {
  height: 10px;
  width: 10px;
  background-color: #ce5555;
  display: block;
  top: 0px;
  right: 0px;
  z-index: 100000;
}
.modal-open .float_quick_block {
  right: 25px;
}
</style>
